export function getAntdPopupContainer(triggerNode?: HTMLElement): HTMLElement {
  if (!triggerNode) return document.body

  // 弹窗和抽屉内部有独立滚动区域，弹层需要随表单控件一起滚动。
  const scrollingOverlay = triggerNode.closest<HTMLElement>('.ant-modal-body, .ant-drawer-body')
  if (scrollingOverlay) {
    return triggerNode.parentElement || scrollingOverlay
  }

  // 普通页面统一挂到 body，避免卡片的 overflow 裁剪或干扰弹层方向计算。
  return document.body
}
